import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    itemRef: PropTypes.string,
    key: PropTypes.string,
    value: PropTypes.string
  })
);
